import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { WEB_COMPONENT_ALERTS } from '../../webcomponents.constants';
import { AlertsWebComponent } from '../../alerts';
import { AlertsAppData } from '../types';

export class AlertsAppView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');
  }

  buildSuccessView(data: AlertsAppData) {
    this.dom.$wrapper.innerHTML = '';
    const $alertsWebComponent = document.createElement(WEB_COMPONENT_ALERTS) as AlertsWebComponent;
    $alertsWebComponent.injectDependencies(this.dependencies);

    if (Object.keys(data.externalParams).length) {
      $alertsWebComponent.externalParams = data.externalParams;
    }

    this.dom.$wrapper.appendChild($alertsWebComponent);
    $alertsWebComponent.start().then().catch(console.error);
  }
}
